import { observer } from "mobx-react-lite";
import React, { Fragment, useEffect, useContext, Component } from "react";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import DashboardStore from "../../../app/stores/DashboardStore";
import axios, { AxiosResponse } from "axios";
import { Report } from 'powerbi-report-component';
import { render } from "react-dom";
import { disconnect } from "process";


import config from '../../../app/api/apiconfig';



 


const baseURL = config.app.baseUrl
const tokenUrl = config.app.tokenUrl







interface IProps{}

let sessionObj = JSON.parse(sessionStorage.getItem("sessionObj")!)
let IsLoggedIn = sessionStorage.getItem("isLoggedIn")


const responseBody = (response: AxiosResponse) => response.data;


const requests = {
  get: (url: string) => axios.get(url).then(responseBody),
  post: (url: string, body: string) => axios.post(url, body).then(responseBody),
};
    

const reportStyle = {
  height:"800px",
  width:"1000px"
};




async function gettoken(){
  //if token already exists.
  var token:string
  var tk = await axios({
      method:"post",
      //url:"https://gilm-clientportal-test.azurewebsites.net/CP/token/gettoken",
      url:tokenUrl
  }).then((response) => {
    (token = response.data)
    var tokebe:string = token.substr(16, token.length-4)
    var tokenonly:string = tokebe.slice(0, -1)
    return tokenonly
  }
  ) 

  sessionStorage.setItem('token', tk)
  


  }

 
  function delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
}


gettoken()



const RedKiteDash: React.FC<IProps> = props => {
  const arg = useContext(DashboardStore);
  if(arg.loadinginital){
  return <LoadingComponent content = {"Loading: Dashboards"} inverted={false}/>
  
;}
   
  gettoken()
  var tk:string = JSON.stringify(sessionStorage.getItem('token'))
  var tokebe:string = tk.substr(1, tk.length-1)
  var tokenonly:string = tokebe.slice(0, -1)
  console.log(tokenonly)
    return <div>
    <Report
    tokenType="Aad" // or, "Aad"
    accessToken={tokenonly} // accessToken goes here
    embedUrl="https://app.powerbi.com/reportEmbed?reportId=98d84234-bf02-4414-83ac-5e03efac0e66&groupId=4df8742f-15e9-4a12-9e3d-35405523ef6e" // embedUrl goes here
    embedId="98d84234-bf02-4414-83ac-5e03efac0e66" // report or dashboard Id goes here
    pageName="1" // set as current page of the report
    reportMode="View"
    permissions="All" // View
    style={reportStyle}
    />
    </div>
}



export default RedKiteDash;